import mainViewMixin from '../mainViewMixin';
export default {
  name: 'ViewNiotaClassicConsumersConsumerList',
  mixins: [mainViewMixin],
  data: function () {
    return {
      isLoadingAccounts: true,
      selectedAccounts: []
    };
  },
  computed: {
    headerBG() {
      return './img/consumer.png';
    }
  },
  methods: {
    editConsumer(item) {
      this.pushToRouter(`/niota-classic/consumers/${item.id}`);
    },
    pushToRouter(path) {
      this.$router.push({
        path: path
      });
    },
    resetFilter() {
      this.selectedAccounts = [];
    }
  }
};